<!-- 教务处老师列表 -->
<template>
  <div class="list3">
    <ul class="table-title">
      <li>
        <span>姓名</span>
      </li>
      <li><span>性别</span></li>
      <li><span>职务</span></li>
      <li><span>联系方式</span></li>
      <li><span>状态</span></li>
      <li><span>拔打电话</span></li>
    </ul>
     <ul
      class="table-data"
      v-for="(item, index) in dataList" :key="index"
    >
      <li>
        <span class="data-name">
          {{item.name}}
        </span>
      </li>
      <li>
        <span>{{item.sex==1?'男':'女'}}</span>
      </li>
      <li>
        <span> {{item.work}}</span>
      </li>
      <li>
        <span>{{item.mobile}}</span>
      </li>
      <li>{{item.status==1?'在职':'未在职'}}</li>
      <li>
        <img src="./../../assets/39.png" alt="电话" class="phone">
      </li>
    </ul>

    <p class="no-style" v-if="dataList == null">暂无数据</p>
    <el-pagination
      style="text-align:center;margin-top:35px"
      v-if="dataList != null"
      background
      layout="prev, pager, next"
      :total="total"
      :page-size="20"
      @current-change="handleCurrentChange"
      @prev-click="handleCurrentChange"
      @next-click="handleCurrentChange"
    >
    </el-pagination>
  </div>
</template>

<script>
import { getContactTeacherList } from "@/api/home";
import { getActive, setActive, removeActive } from "@/utils/auth";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      page:1,
      total: 0,
      dataList: [],
    };
  },
  //监听属性 类似于data概念
  computed: {
    device() {
      return this.$store.state.app.device;
    },
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    handleCurrentChange(val) {
      this.page = val;
      this.fetchData();
    },
    jumpD(id) {
      this.$router.push({
        path: "/serve/serve-teacher/serve-list3d",
        query: {
          id: id,
        },
      });
      setActive('5-3-1')
      this.$store.dispatch("user/setActive",'5-3-1');
    },
    fetchData() {
      let params1 = {
        page: this.page,
        type: 1,
      };
      getContactTeacherList(params1).then((response) => {
        this.dataList = response.data;
        this.total = response.total;
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.fetchData();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
};
</script>
<style lang="scss" scoped>
.list3 {
  height: 100%;
  padding-top: 45px;
  padding-bottom: 50px;
  .no-style {
    font-size: 18px;
    text-align: center;
    padding-top: 20px;
    padding-bottom: 20px;
    border: 1px solid #035bb2;
  }
  .table-title {
    background-color: #035bb2;
    display: grid;
    @media screen and (max-width: 768px) {
      grid-template-columns:
        minmax(70px, 1fr) minmax(70px, 1fr) minmax(70px, 1fr) minmax(80px, 1fr)
        70px 85px;

      font-size: 14px;
    }
    grid-template-columns:
       1fr 1fr 1fr 1fr 80px 90px;
    grid-template-rows: 50px;
    color: #ffffff;
    font-size: 18px;
    line-height: 50px;
    li:not(:first-of-type) {
      text-align: center;
    }
    li:first-child {
      padding-left: 40px;
      @media screen and (max-width: 768px) {
       padding-left: 25px;
      }
    }
  }
  .table-data:nth-child(odd) {
    background-color: #ffffff;
  }
  .table-data:nth-child(even) {
    background-color: #f4f4f4;
  }
  .table-data {
    li {
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      word-break: break-all;
    }
    .data-name {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      word-break: break-all;
      padding-left: 20px;
      @media screen and (max-width: 768px) {
       padding-left: 0px;
      }
      img {
        display: inline-block;
        margin-right: 15px;
        width: 10px;
        height: 10px;
      }
    }
    display: grid;
    @media screen and (max-width: 768px) {
      grid-template-columns:
        minmax(70px, 1fr) minmax(70px, 1fr) minmax(70px, 1fr) minmax(80px, 1fr)
        70px 85px;
      font-size: 12px;
    }
    grid-template-columns:
       1fr 1fr 1fr 1fr 80px 90px;

    grid-template-rows: 50px;
    color: #333333;
    font-size: 14px;
    line-height: 50px;
    .phone{
      width: 20px;height: 20px;top: 13px;right:33px;position: absolute;
    }
    li{
      position: relative;
    }
    li:not(:first-of-type) {
      text-align: center;
    }
    li:first-child {
      padding-left: 20px;
    }
    button {
      cursor: pointer;
      border: none;
      outline: none;
      color: #2968b7;
      font-size: 12px;
      background-color: transparent;
    }
  }
  .pagination {
    margin-top: 35px;
    height: 45px;
  }
}
</style>


</style>